/**
 * Conexão "Apenas receptiva" não entra no disparo de campanhas (não lista no UI).
 * @param {object} w - registo retornado por GET /whatsapp
 * @returns {boolean}
 */
export const isWhatsappEligibleForCampaigns = (w) => Boolean(w && w.inboundOnly !== true);

export const filterWhatsappListForCampaigns = (whatsapps) =>
  (whatsapps || []).filter(isWhatsappEligibleForCampaigns);
